import * as api from "../transport/api/role-api.js";

export async function loadRoles() {
  // 公共角色 + 用户私有角色(后端已合并返回)
  return api.listRoles();
}

export async function loadUserRoles() {
  return api.listUserRoles();
}

export async function createUserRole(payload) {
  return api.createUserRole(payload);
}

export async function updateUserRole(id, payload) {
  return api.updateUserRole(id, payload);
}

export async function deleteUserRole(id) {
  return api.deleteUserRole(id);
}
